<script lang="ts">
    import CheckoutServiceItem from "./CheckoutServiceItem.svelte";

    export let items: Array<any>;
    export let title: string;
</script>
{#if items.length > 0}
    <div class="py-15">
        <h2 class="block mb-1">{title}</h2>
        <div>
            {#each items as product}
                <CheckoutServiceItem data="{product}"/>
            {/each}
        </div>
    </div>
{/if}